import InvoiceTypeModel        from 'Models/invoice/InvoiceTypeModel';
import doc                    from 'decorators/doc';
import model                  from 'decorators/model';
import { Blamable }           from 'helpers/traits';
import { Timestampable }      from 'helpers/traits';
import InvoicePrivateApiModel from '../../abstracts/InvoicePrivateApiModel';

@model.staticLabel('Raison de facture / avoir', false)
@model.urnResource('invoice_reason')
@doc.path('/invoice_reasons/{?id}')
export default class InvoiceReasonModel extends Blamable(Timestampable(InvoicePrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'enabled': boolean;
		'invoiceType': id;
		'invoiceType.reference': InvoiceInvoiceTypeReference;
		'label': string;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'label': string;
		'position': string;
	}> = {};

	@doc.boolean declare enabled: boolean;
	@doc.model(InvoiceTypeModel) declare invoiceType: InvoiceTypeModel;
	@doc.string declare label: string;
	@doc.number declare position: number;
}
